import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../utils";

export const studentExamDetails = createAsyncThunk('studentExamDetails', async ({ id, studentId, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `student_exam_details?student_exam_id=${id}&student_id=${studentId}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const studentExamDetailsSlice = createSlice({
    name: 'studentExamDetails',
    initialState: { data: null },
    extraReducers: (builder) => {
        builder.addCase(studentExamDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = null
            }
        });
    }
})

export default studentExamDetailsSlice.reducer;
